var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 10L6.66637 12.5923V10.6481H12.6658V9.35194H6.66637V7.40771L3.33337 10Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 4.16671C9.87844 4.16458 9.09761 4.31454 8.36941 4.6079C7.64121 4.90125 6.98012 5.33217 6.42444 5.87568L7.36701 6.79206C8.24826 5.93531 9.42014 5.46286 10.6667 5.46286C11.9132 5.46286 13.0851 5.93531 13.9663 6.79206C14.8476 7.64882 15.3335 8.78813 15.3335 10C15.3335 11.2119 14.8476 12.3512 13.9663 13.208C13.0851 14.0648 11.9132 14.5372 10.6667 14.5372C9.42014 14.5372 8.24826 14.0648 7.36701 13.208L6.42444 14.1244C7.55699 15.2261 9.06351 15.8334 10.6667 15.8334C12.2699 15.8334 13.7764 15.2261 14.9089 14.1244C16.0421 13.0233 16.6667 11.5587 16.6667 10C16.6667 8.44141 16.0421 6.97676 14.9089 5.87568C14.3532 5.33217 13.6922 4.90125 12.964 4.6079C12.2358 4.31454 11.4549 4.16458 10.6667 4.16671V4.16671Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.5e532bf0026535e600b6c3e670615411.svg";
export { ForwardRef as ReactComponent };